import React from "react";

/**
 * Label for a filter trigger button ("Age Range", "Line/Color", "Gender",
 * "Selected", "State") that also carries the value currently applied, so the
 * list reader can tell at a glance which filters are narrowing the table.
 *
 * Unapplied: the plain label. Applied: `Label: Value` with the value in the
 * accent colour (and `selection-drop--active` on the trigger — see App.css).
 */

/** "Red, Blue" or "Red, Blue +2" — keeps the trigger from growing unbounded. */
export const formatFilterValueList = (values, max = 2) => {
  const list = (values || []).filter(Boolean);
  if (list.length === 0) return "";
  if (list.length <= max) return list.join(", ");
  return `${list.slice(0, max).join(", ")} +${list.length - max}`;
};

export const FilterTriggerLabel = ({ label, value }) => {
  if (!value) return <>{label}</>;
  return (
    <span className="filter-trigger-label" title={`${label}: ${value}`}>
      <span className="filter-trigger-label__name">{label}:</span>{" "}
      <span className="filter-trigger-label__value">{value}</span>
    </span>
  );
};

/** Class list for a trigger: the base classes plus the active flag. */
export const filterTriggerClass = (base, isActive) =>
  isActive ? `${base} selection-drop--active` : base;
